import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
const Title = ({ value }) => {
  return /* @__PURE__ */ React.createElement(Heading, { className: "mini-cart-v2__title", component: "h1", variant: "smallest" }, value);
};
export {
  Title
};
//# sourceMappingURL=Title.js.map
